let Handlebars = require('handlebars');

module.exports = function () {
    var args = Array.prototype.slice.call(arguments), value, precision;
    args.pop();
    value = args[0] || 0;
    precision = args.length == 2 ? args[1] : 2;
    if (typeof value === 'string') {
        value = parseFloat(value);
    }
    return new Handlebars.SafeString(value.toFixed(precision))
};


// WEBPACK FOOTER //
// ./src/hbHelpers/toFixed.js